import { PosAbsolute, PosRelative } from '@layout/BuildingBlocks'
import React from 'react'

export const DragnetInvestigationIcon = ({
  size = 32,
  width,
  iconColor = '#4C4D4C',
  backgroundColor = '#B198BD',
  strokeWidth,
  shadow = true,
}) => {
  return (
    <PosRelative width={width || size} height="100%">
      <PosAbsolute>
        <svg
          width={width || size}
          height="100%"
          viewBox="0 0 32 32"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle cx="18.5" cy="19.5" r="12.5" fill={backgroundColor} />
        </svg>
      </PosAbsolute>
      <PosAbsolute>
        <svg
          width={width || size}
          height="100%"
          viewBox="0 0 32 32"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          style={{ filter: shadow && 'drop-shadow(0 5px 3px #bfbfbf)' }}
        >
          <path
            d="M9 21H8V4.5C8 4.36739 8.05268 4.24021 8.14645 4.14645C8.24021 4.05268 8.36739 4 8.5 4C8.63261 4 8.75979 4.05268 8.85355 4.14645C8.94732 4.24021 9 4.36739 9 4.5V21ZM10.5 22H6.5C6.36739 22 6.24021 22.0527 6.14645 22.1464C6.05268 22.2402 6 22.3674 6 22.5C6 22.6326 6.05268 22.7598 6.14645 22.8536C6.24021 22.9473 6.36739 23 6.5 23H8V26.5C8 26.6326 8.05268 26.7598 8.14645 26.8536C8.24021 26.9473 8.36739 27 8.5 27C8.63261 27 8.75979 26.9473 8.85355 26.8536C8.94732 26.7598 9 26.6326 9 26.5V23H10.5C10.6326 23 10.7598 22.9473 10.8536 22.8536C10.9473 22.7598 11 22.6326 11 22.5C11 22.3674 10.9473 22.2402 10.8536 22.1464C10.7598 22.0527 10.6326 22 10.5 22ZM17 4.5C17 4.36739 16.9473 4.24021 16.8536 4.14645C16.7598 4.05268 16.6326 4 16.5 4C16.3674 4 16.2402 4.05268 16.1464 4.14645C16.0527 4.24021 16 4.36739 16 4.5V12H17V4.5ZM18.5 13H14.5C14.3674 13 14.2402 13.0527 14.1464 13.1464C14.0527 13.2402 14 13.3674 14 13.5C14 13.6326 14.0527 13.7598 14.1464 13.8536C14.2402 13.9473 14.3674 14 14.5 14H16V26.5C16 26.6326 16.0527 26.7598 16.1464 26.8536C16.2402 26.9473 16.3674 27 16.5 27C16.6326 27 16.7598 26.9473 16.8536 26.8536C16.9473 26.7598 17 26.6326 17 26.5V14H18.5C18.6326 14 18.7598 13.9473 18.8536 13.8536C18.9473 13.7598 19 13.6326 19 13.5C19 13.3674 18.9473 13.2402 18.8536 13.1464C18.7598 13.0527 18.6326 13 18.5 13ZM26.5 19H22.5C22.3674 19 22.2402 19.0527 22.1464 19.1464C22.0527 19.2402 22 19.3674 22 19.5C22 19.6326 22.0527 19.7598 22.1464 19.8536C22.2402 19.9473 22.3674 20 22.5 20H24V26.5C24 26.6326 24.0527 26.7598 24.1464 26.8536C24.2402 26.9473 24.3674 27 24.5 27C24.6326 27 24.7598 26.9473 24.8536 26.8536C24.9473 26.7598 25 26.6326 25 26.5V20H26.5C26.6326 20 26.7598 19.9473 26.8536 19.8536C26.9473 19.7598 27 19.6326 27 19.5C27 19.3674 26.9473 19.2402 26.8536 19.1464C26.7598 19.0527 26.6326 19 26.5 19ZM25 4.5C25 4.36739 24.9473 4.24021 24.8536 4.14645C24.7598 4.05268 24.6326 4 24.5 4C24.3674 4 24.2402 4.05268 24.1464 4.14645C24.0527 4.24021 24 4.36739 24 4.5V18H25V4.5Z"
            fill={iconColor}
            stroke={iconColor}
            strokeWidth={strokeWidth}
          />
        </svg>
      </PosAbsolute>
    </PosRelative>
  )
}
